import importsStore from "@/app/imports/store/imports";
import templatesStore from "@/app/imports/store/templates";

export default {
  modules: {
    importsStore,
    templatesStore,
  },
};
